export const SIDEBAR_WIDTH = 264;
